// petz-product.js — Product page variant selection via option_values/SRA. No jQuery.

(function () {
  'use strict';

  var SECTION_ATTR = 'data-petz-product-section';
  var SECTION_SEL = '[' + SECTION_ATTR + ']';

  // ─── Per-section init ────────────────────────────────────────────────────────

  function init(section) {
    if (section.dataset.petzProductReady) return;
    section.dataset.petzProductReady = '1';

    var sectionId     = section.getAttribute(SECTION_ATTR);
    var productUrl    = section.getAttribute('data-petz-product-url')    || '';
    var productId     = section.getAttribute('data-petz-product-id')     || '';
    var productTitle  = section.getAttribute('data-petz-product-title')  || '';
    var productHandle = section.getAttribute('data-petz-product-handle') || '';
    var currency      = section.getAttribute('data-petz-currency')       || '';
    var msgs = {
      loading:     section.getAttribute('data-petz-msg-loading')     || '',
      error:       section.getAttribute('data-petz-msg-error')       || '',
      available:   section.getAttribute('data-petz-msg-available')   || '',
      soldOut:     section.getAttribute('data-petz-msg-sold-out')    || '',
      unavailable: section.getAttribute('data-petz-msg-unavailable') || ''
    };

    var sraController = null;

    // ── Collect selected option-value IDs from checked radios ────────────────

    function selectedOptionData(changedInput) {
      var ids = [];
      var basePath = productUrl;
      section.querySelectorAll('[data-petz-option-group]').forEach(function (group) {
        var checked = group.querySelector('input[type="radio"]:checked');
        if (checked) {
          ids.push(checked.getAttribute('data-option-value-id'));
          // Use the changed input's product_url as the base path when available
          if (checked === changedInput) {
            var pu = checked.getAttribute('data-product-url');
            if (pu) basePath = pu.split('?')[0];
          }
        } else {
          ids.push(null);
        }
      });
      // If no option-value IDs found yet (e.g. single-variant), use product URL path only
      if (!basePath) basePath = productUrl;
      return { ids: ids, basePath: basePath };
    }

    // ── Section Rendering API via option_values ──────────────────────────────

    function fetchSection(ids, basePath) {
      if (sraController) sraController.abort();
      sraController = new AbortController();
      var url = basePath
        + '?option_values=' + ids.join(',')
        + '&sections=' + encodeURIComponent(sectionId);
      return fetch(url, { signal: sraController.signal })
        .then(function (res) {
          if (!res.ok) return null;
          return res.json().then(function (data) {
            return data[sectionId] || null;
          });
        })
        .catch(function (err) {
          if (err.name !== 'AbortError') console.warn('[petz-product] SRA failed', err);
          return null;
        });
    }

    // ── Replace section; announce new state; restore focus ───────────────────

    function applyNewSection(html, lastChangedId) {
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      var newSection = tmp.querySelector(SECTION_SEL);
      if (!newSection) return null;

      // Announce state BEFORE replacing so the new announcer is ready
      var newAnnouncer = newSection.querySelector('[data-petz-product-announcer]');
      if (newAnnouncer) {
        var priceBlock = newSection.querySelector('[data-petz-price-block]');
        var atcBtn     = newSection.querySelector('[data-petz-atc-btn]');
        var stateMsg   = '';
        if (priceBlock && priceBlock.hasAttribute('hidden')) {
          stateMsg = newSection.getAttribute('data-petz-msg-unavailable') || msgs.unavailable;
        } else if (atcBtn && (atcBtn.hasAttribute('disabled') || atcBtn.getAttribute('aria-disabled') === 'true')) {
          stateMsg = newSection.getAttribute('data-petz-msg-sold-out') || msgs.soldOut;
        } else {
          stateMsg = newSection.getAttribute('data-petz-msg-available') || msgs.available;
        }
        newAnnouncer.textContent = stateMsg;
      }

      section.replaceWith(newSection);

      // Restore focus to the option-value input that triggered the change
      if (lastChangedId) {
        var target = newSection.querySelector('[data-option-value-id="' + lastChangedId + '"]');
        if (target) target.focus();
      }

      init(newSection);
      return newSection;
    }

    // ── Handle option change ──────────────────────────────────────────────────

    function onOptionChange(changedInput) {
      var data = selectedOptionData(changedInput);
      var ids      = data.ids;
      var basePath = data.basePath;

      if (ids.some(function (id) { return id == null; })) return;

      // selectedOptions: server-rendered option names + current DOM radio values
      var optNames = [];
      try { optNames = JSON.parse(section.getAttribute('data-petz-option-names') || '[]'); } catch (_) {}
      var selectedOptions = [];
      var _oi = 0;
      section.querySelectorAll('[data-petz-option-group]').forEach(function (group) {
        var checked = group.querySelector('input[type="radio"]:checked');
        if (checked && _oi < optNames.length) {
          selectedOptions.push({ name: optNames[_oi], value: checked.value });
        }
        _oi++;
      });

      // Dispatch shopify:product:select BEFORE the SRA request via official ProductSelectEvent
      var PSE = window.Shopify
        && window.Shopify.StandardEvents
        && window.Shopify.StandardEvents.ProductSelectEvent;

      var deferred = null;

      if (!PSE || typeof PSE.createPromise !== 'function') {
        console.error('[petz-product] Shopify.StandardEvents.ProductSelectEvent unavailable — standard event not dispatched');
      } else {
        deferred = PSE.createPromise();
        section.dispatchEvent(new PSE({
          selectedOptions: selectedOptions,
          product: { id: productId, title: productTitle, handle: productHandle },
          promise: deferred.promise
        }));
      }

      var announcer = section.querySelector('[data-petz-product-announcer]');
      var atcBtn    = section.querySelector('[data-petz-atc-btn]');

      section.setAttribute('aria-busy', 'true');
      if (atcBtn && !atcBtn.hasAttribute('disabled')) {
        atcBtn.disabled = true;
        atcBtn.setAttribute('aria-disabled', 'true');
        atcBtn._petzWasEnabled = true;
      }
      if (announcer) {
        announcer.textContent = '';
        announcer.textContent = msgs.loading;
      }

      var lastChangedId = changedInput ? changedInput.getAttribute('data-option-value-id') : null;

      fetchSection(ids, basePath).then(function (html) {
        if (!html) {
          if (deferred) deferred.reject(new Error('[petz-product] SRA fetch failed'));
          section.removeAttribute('aria-busy');
          if (atcBtn && atcBtn._petzWasEnabled) {
            atcBtn.disabled = false;
            atcBtn.removeAttribute('aria-disabled');
            delete atcBtn._petzWasEnabled;
          }
          if (announcer) {
            announcer.textContent = '';
            announcer.textContent = msgs.error;
          }
          return;
        }

        try {
          var newUrl = new URL(basePath, window.location.origin);
          newUrl.searchParams.set('option_values', ids.join(','));
          window.history.replaceState({}, '', newUrl.pathname + newUrl.search);
        } catch (_) {}

        var newSection;
        try {
          newSection = applyNewSection(html, lastChangedId);
        } catch (ex) {
          if (deferred) deferred.reject(ex);
          return;
        }

        if (!newSection) {
          if (deferred) deferred.reject(new Error('[petz-product] required product section missing in SRA response'));
          return;
        }

        // Server-authoritative variant state from the newly rendered section
        var variantGid = newSection.getAttribute('data-petz-variant-gid') || '';

        if (!variantGid) {
          if (deferred) deferred.resolve({ variant: null });
          return;
        }

        var available       = newSection.getAttribute('data-petz-available')        === 'true';
        var price           = newSection.getAttribute('data-petz-price')            || '';
        var resolvedCur     = newSection.getAttribute('data-petz-currency')         || currency;
        var resolvedOptions = [];
        try {
          resolvedOptions = JSON.parse(newSection.getAttribute('data-petz-selected-options') || '[]');
        } catch (_) {}

        if (deferred) {
          deferred.resolve({
            variant: {
              id:               variantGid,
              title:            resolvedOptions.map(function (o) { return o.value; }).join(' / '),
              availableForSale: available,
              price:            { amount: price, currencyCode: resolvedCur },
              selectedOptions:  resolvedOptions
            }
          });
        }
      });
    }

    // ── Gallery: activate a media item by its Shopify media ID ───────────────

    function activateMedia(mediaId) {
      section.querySelectorAll('[data-petz-media-item]').forEach(function (item) {
        item.hidden = (parseInt(item.getAttribute('data-petz-media-item'), 10) !== mediaId);
      });
      section.querySelectorAll('[data-petz-thumb]').forEach(function (thumb) {
        var active = (parseInt(thumb.getAttribute('data-petz-thumb'), 10) === mediaId);
        thumb.classList.toggle('petz-main-product__thumb--active', active);
        thumb.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    // ── Quantity stepper ──────────────────────────────────────────────────────

    function initQtyStepper() {
      function syncButtons(input) {
        var min = Number(input.min || 1);
        var max = input.max === '' ? Infinity : Number(input.max);
        var val = Number(input.value || min);
        var dec = section.querySelector('[data-petz-qty-dec]');
        var inc = section.querySelector('[data-petz-qty-inc]');
        if (dec) dec.disabled = val <= min;
        if (inc) inc.disabled = max !== Infinity && val >= max;
      }

      section.addEventListener('click', function (e) {
        var dec = e.target.closest('[data-petz-qty-dec]');
        var inc = e.target.closest('[data-petz-qty-inc]');
        if (!dec && !inc) return;
        var input = section.querySelector('[data-petz-qty-input]');
        if (!input) return;
        var min  = Number(input.min  || 1);
        var step = Number(input.step || 1);
        var max  = input.max === '' ? Infinity : Number(input.max);
        var val  = Number(input.value || min);
        input.value = dec ? Math.max(min, val - step) : Math.min(max, val + step);
        syncButtons(input);
        input.dispatchEvent(new Event('input',  { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });

      var input = section.querySelector('[data-petz-qty-input]');
      if (input) syncButtons(input);
    }

    // ── Event listeners ───────────────────────────────────────────────────────

    section.addEventListener('change', function (e) {
      if (e.target.type === 'radio' && e.target.closest('[data-petz-option-group]')) {
        onOptionChange(e.target);
      }
    });

    section.addEventListener('click', function (e) {
      var thumb = e.target.closest('[data-petz-thumb]');
      if (thumb) activateMedia(parseInt(thumb.getAttribute('data-petz-thumb'), 10));
    });

    initQtyStepper();
    fetchComplementary(section);
  }

  // ─── Complementary products (async SRA fetch) ────────────────────────────────
  //
  // The placeholder may contain a pre-rendered empty-state <p>. We track
  // whether we have already fetched via a data attribute so re-renders after
  // SRA variant swaps work correctly on the fresh section.

  function fetchComplementary(section) {
    var placeholder = section.querySelector('[data-petz-complementary]');
    if (!placeholder || placeholder.dataset.petzCompDone) return;
    placeholder.dataset.petzCompDone = '1';
    var url = placeholder.getAttribute('data-petz-comp-url');
    if (!url) return;

    fetch(url)
      .then(function (res) {
        if (!res.ok) return null;
        return res.text();
      })
      .then(function (html) {
        if (!html) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var inner = tmp.querySelector('.petz-complementary');
        if (inner) {
          placeholder.innerHTML = '';
          placeholder.appendChild(inner);
        }
        // If no .petz-complementary in response, empty-state text stays visible.
      })
      .catch(function () {
        // Silent fail — empty-state text remains visible.
      });
  }

  // ─── Related products (async SRA fetch, intent=related) ─────────────────────
  //
  // Finds [data-petz-related-products] anywhere in the document. Builds the
  // request from data attributes on the slot. On success, replaces only the
  // slot inner content — the server-rendered collection group is untouched.
  // Fails silently so collection pathways always remain visible.

  function fetchRelated() {
    var slot = document.querySelector('[data-petz-related-products]');
    if (!slot || slot.dataset.petzRelDone) return;
    slot.dataset.petzRelDone = '1';

    var baseUrl    = slot.getAttribute('data-petz-rel-url');
    var productId  = slot.getAttribute('data-petz-rel-product');
    var sectionId  = slot.getAttribute('data-petz-rel-section');
    var limit      = slot.getAttribute('data-petz-rel-limit') || '4';
    var section    = slot.closest('.petz-related');
    var colCount   = section ? parseInt(section.getAttribute('data-petz-rel-col-count') || '0', 10) : 0;
    var designMode = !!(window.Shopify && window.Shopify.designMode);

    if (!baseUrl || !productId || !sectionId) return;

    var url = baseUrl
      + '?section_id=' + encodeURIComponent(sectionId)
      + '&product_id=' + encodeURIComponent(productId)
      + '&limit='      + encodeURIComponent(limit)
      + '&intent=related';

    slot.setAttribute('aria-busy', 'true');

    // Hide the entire section when both groups are empty on the live storefront.
    function suppressed() {
      if (colCount === 0 && section && !designMode) section.hidden = true;
    }

    fetch(url)
      .then(function (res) {
        if (!res.ok) return null;
        return res.text();
      })
      .then(function (html) {
        slot.removeAttribute('aria-busy');
        if (!html) { suppressed(); return; }

        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var newSlot = tmp.querySelector('[data-petz-related-products]');
        if (!newSlot) { suppressed(); return; }

        // Only replace when the response contains at least one product card.
        if (!newSlot.querySelector('[data-petz-product-card]')) { suppressed(); return; }

        slot.innerHTML = newSlot.innerHTML;
      })
      .catch(function () {
        slot.removeAttribute('aria-busy');
        suppressed();
      });
  }

  // ─── Bootstrap ──────────────────────────────────────────────────────────────

  document.querySelectorAll(SECTION_SEL).forEach(init);
  fetchRelated();

  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector(SECTION_SEL)
            || (e.target.matches && e.target.matches(SECTION_SEL) ? e.target : null);
    if (s) init(s);

    // Re-fetch related products when the related section reloads in the editor
    if (e.target.querySelector('[data-petz-related-products]')) fetchRelated();
  });

  document.addEventListener('shopify:block:load', function (e) {
    var s = e.target.closest(SECTION_SEL);
    if (s) { delete s.dataset.petzProductReady; init(s); }
  });

})();
